class PopupUnsupportedCountry extends HTMLElement {
  constructor() {
    super();
    this.modal = document.querySelector(`#${this.dataset.modal}`);
    this.cookieName = 'popup-unsupported-country';
    this.storageKey = 'lb_detected_country';
    this.availableCountries = this.dataset.availableCountries.split(',').filter(Boolean);

    const previewCountry = new URLSearchParams(window.location.search).get('unsupported_country_preview');
    if (previewCountry) {
      this.check(previewCountry.toUpperCase(), false);
      return;
    }

    if (checkCookies(this.cookieName) || !this.availableCountries.length) return;

    this.detectCountry().then((country) => this.check(country, true));
  }

  async detectCountry() {
    try {
      const stored = sessionStorage.getItem(this.storageKey);
      if (stored) return stored;
    } catch (e) {}

    try {
      const response = await fetch('/browsing_context_suggestions.json?country[enabled]=true');
      const data = await response.json();
      const country = data?.detected_values?.country?.handle;
      if (country) {
        try {
          sessionStorage.setItem(this.storageKey, country);
        } catch (e) {}
      }
      return country;
    } catch (e) {
      return null;
    }
  }

  check(country, persist) {
    if (!country || this.availableCountries.includes(country)) return;

    this.modal.show();
    if (!persist) return;

    addCookie(this.cookieName, 'shown', 7);
    // Keep the newsletter popup from opening on top of this one.
    addCookie('popup-optin-newsletter', 'shown', 7);
  }
}

customElements.define('popup-unsupported-country', PopupUnsupportedCountry);
